import { render } from "./SSwitch.vue?vue&type=template&id=3fc5e0b0&scoped=true&ts=true"
import script from "./SSwitch.ts?vue&type=script&lang=ts"
export * from "./SSwitch.ts?vue&type=script&lang=ts"

import "./SSwitch.scss?vue&type=style&index=0&id=3fc5e0b0&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc5e0b0"]])

export default __exports__